import styled from "styled-components";

export const ConnectorLine = styled.hr`
  height: 2px;
  width: 48px;
  position: absolute;
  left: calc(100% + 1px);
  background-color: #858585;
`;
